import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  createTheme,
  ThemeProvider,
  CssBaseline,
  Box,
  Typography,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { keyframes } from "@emotion/react"; // For creating custom animations

// Custom theme for styling
const theme = createTheme();

// Typing animation for the text
const typingAnimation = keyframes`
  0% { width: 0%; }
  100% { width: 100%; }
`;

// Blinking cursor effect
const blinkCursor = keyframes`
  50% { border-color: transparent; }
`;

function WelcomePage() {
  const [direction, setDirection] = useState("ltr");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [text, setText] = useState("WELCOME TO TURKISH CLINIC");

  useEffect(() => {
    const savedDirection = localStorage.getItem("direction");
    setDirection(savedDirection || "ltr");
    document.body.setAttribute("dir", direction);
  }, [direction]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box
        sx={{
          backgroundColor: "#f9f9f9",
          padding: { xs: "1rem", sm: "2rem" }, // Adjust padding based on screen size
          minHeight: "80vh",
        }}
      >
        <Grid
          container
          sx={{
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            textAlign: "center",
          }}
        >
          <Grid item xs={12} sm={8} md={6}>
            {/* Typing animation */}
            <Typography
              sx={{
                fontSize: { xs: "1.9rem", sm: "2rem" },
                fontWeight: "bold",
                marginBottom: "1rem",
                whiteSpace: "nowrap",
                overflow: "hidden",
                borderRight: "3px solid #B70000", // Creates the cursor effect
                width: "100%",
                animation: `${typingAnimation} 4s steps(30) infinite, ${blinkCursor} 0.75s step-end infinite`,
              }}
            >
              {text}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "2rem",
                width: "100vw", // Ensure the container is responsive
                maxWidth: "750px", // Max width for logo container
                height: "60vh", // Adjust height to maintain aspect ratio
                margin: "0 auto",
              }}
            >
              <img
                src={`${process.env.REACT_APP_MEDIA_URL}/images/logo/logo.png`} // Logo path
                alt="Turkish Clinic Logo"
                style={{
                  maxWidth: "100%", // Ensure image is responsive
                  height: "auto", // Maintain aspect ratio
                  animation: `${blinkCursor} 2s infinite`, // Optional animation for logo if needed
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </ThemeProvider>
  );
}

export default WelcomePage;
